import {
    GetCommonDDLList, ZC_GetOrderList, ZC_GetPlanList,ImportOrderExcel,ZC_GetPlanList_ByCate
    ,ZC_GetClientList,ZC_GetResultList,ZC_Index
    ,ZC_GetTrainList,ZC_GetAlertList,ZC_GetAgentList
} from '@/api/zc'
import {getToken, removeToken, setToken} from '@/utils/auth'
import {resetRouter} from '@/router'

// 用户记录
const state = {
    orderStatusList: [],
    productList:[],
    planStatusList:[],  
    clientDictList:[],//客户字典列表
    agentDictList:[],//代理商字典列表
    serviceTypeList:[], 
    trainTypeList:[],
    segList:[],
    provideList:[],
    renewList:[],//Renew 结果
    
    orderList:[],
    planList:[],
    importOrderExcel:[],
    planList_ByCate:[],

    clientList:[],
    agentList:[],
    clientOrderList:[],

    resultList:[],

    ZC_Index:[],

    trainList:[],
    alertList:[],
};

const mutations = {    
    orderStatusList: (state, list) => {
        state.orderStatusList = list;
    },
    productList: (state, list) => {
        state.productList = list;
    },
    planStatusList: (state, list) => {
        state.planStatusList = list;
    },
    clientDictList: (state, list) => {
        state.clientDictList = list;
    },
    agentDictList: (state, list) => {
        state.agentDictList = list;
    },
    serviceTypeList: (state, list) => {
        state.serviceTypeList = list;
    },
    trainTypeList: (state, list) => {
        state.trainTypeList = list;
    },
    segList: (state, list) => {
        state.segList = list;
    },
    provideList: (state, list) => {
        state.provideList = list;
    },
    renewList: (state, list) => {
        state.renewList = list;
    },

    
    orderList: (state, list) => {
        state.orderList = list;
    },
    planList: (state, list) => {
        state.planList = list;
    },
    importOrderExcel: (state, list) => {
        state.importOrderExcel = list;
    },
    planList_ByCate: (state, list) => {
        state.planList_ByCate = list;
    },

    clientList: (state, list) => {
        state.clientList = list;
    },
    agentList: (state, list) => {
        state.agentList = list;
    },
    clientOrderList: (state, list) => {
        state.clientOrderList = list;
    },


    resultList: (state, list) => {
        state.resultList = list;
    },

    ZC_Index: (state, list) => {
        state.ZC_Index = list;
    },

    trainList: (state, list) => {
        state.trainList = list;
    },
    alertList: (state, list) => {
        state.alertList = list;
    },
}

const actions = {    
    async orderStatusList({commit, state},) {
        return GetCommonDDLList({userId: getToken(),type:1}).then(response => {
            commit('orderStatusList', response.data);
        });
    },
    async productList({commit, state},) {
        return GetCommonDDLList({userId: getToken(),type:2}).then(response => {
            commit('productList', response.data);
        });
    },
    async planStatusList({commit, state},) {
        return GetCommonDDLList({userId: getToken(),type:3}).then(response => {
            commit('planStatusList', response.data);
        });
    },
    async clientDictList({commit, state},) {
        return GetCommonDDLList({userId: getToken(),type:4}).then(response => {
            commit('clientDictList', response.data);
        });
    },
    async agentDictList({commit, state},) {
        return GetCommonDDLList({userId: getToken(),type:10}).then(response => {
            commit('agentDictList', response.data);
        });
    },
    async serviceTypeList({commit, state},) {
        return GetCommonDDLList({userId: getToken(),type:5}).then(response => {
            commit('serviceTypeList', response.data);
        });
    },
    async trainTypeList({commit, state},) {
        return GetCommonDDLList({userId: getToken(),type:6}).then(response => {
            commit('trainTypeList', response.data);
        });
    },
    async segList({commit, state},) {
        return GetCommonDDLList({userId: getToken(),type:7}).then(response => {
            commit('segList', response.data);
        });
    },
    async provideList({commit, state},) {
        return GetCommonDDLList({userId: getToken(),type:8}).then(response => {
            commit('provideList', response.data);
        });
    },
    async renewList({commit, state},) {
        return GetCommonDDLList({userId: getToken(),type:9}).then(response => {
            commit('renewList', response.data);
        });
    },



    async orderList({commit, state},{key,statusIds,sDate,eDate,isValidDate,productIds,clientIds=''}) {
        return ZC_GetOrderList({userId: getToken(),key,statusIds,sDate,eDate,isValidDate,productIds,clientIds}).then(response => {
            commit('orderList', response.data);
        });
    },
    async planList({commit, state},{companyId=-1,key='',statusIds='',sDate,eDate}) {
        return ZC_GetPlanList({userId: getToken(),companyId,key,statusIds,sDate,eDate}).then(response => {
            commit('planList', response.data);
        });
    },
    async importOrderExcel({commit, state},{formData}) {
        return ImportOrderExcel({userId: getToken(),formData}).then(response => {
            commit('importOrderExcel', response.data);
        });
    },
    async planList_ByCate({commit, state},{monthSeg='',servicetype='',clientGrade=''}) {
        return ZC_GetPlanList_ByCate({userId: getToken(),monthSeg,servicetype,clientGrade}).then(response => {
            commit('planList_ByCate', response.data);
        });
    },


    async clientList({commit, state},{key}) {
        return ZC_GetClientList({userId: getToken(),key}).then(response => {
            commit('clientList', response.data);
        });
    },
    async agentList({commit, state},{key}) {
        return ZC_GetAgentList({userId: getToken(),key}).then(response => {
            commit('agentList', response.data);
        });
    },

    async clientOrderList({commit, state},{key,statusIds='',sDate='2020-1-1',eDate='2099-12-31',isValidDate='true',productIds='',clientIds}) {
        return ZC_GetOrderList({userId: getToken(),key,statusIds,sDate,eDate,isValidDate,productIds,clientIds}).then(response => {
            commit('clientOrderList', response.data);
        });
    },
    

    async resultList({commit, state},{key='',planId=0,companyId=0,isAgent='0',sDate='',eDate=''}) {
        return ZC_GetResultList({userId: getToken(),key,planId,companyId,isAgent,sDate,eDate}).then(response => {
            commit('resultList', response.data);
        });
    },


    async ZC_Index({commit, state},{}) {
        return ZC_Index({userId: getToken()}).then(response => {
            commit('ZC_Index', response.data);
        });
    },
    
    async trainList({commit, state},{key,typeIds,sDate,eDate}) {
        return ZC_GetTrainList({userId: getToken(),key,typeIds,sDate,eDate}).then(response => {
            commit('trainList', response.data);
        });
    },

    async alertList({commit, state},{}) {
        console.log('safasdfa')
        return ZC_GetAlertList({userId: getToken()}).then(response => {
            
            commit('alertList', response.data);
        });
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}
